const tabs = {
  conversation: { labelKey: 'client.matters.matter_page.conversation_title', icon: 'icon-conversation', cmp: 'Conversation' },
  notes: { labelKey: 'client.matters.matter_page.notes_title', icon: 'icon-note', cmp: 'Notes' },
  bookings: { labelKey: 'client.matters.matter_page.bookings_title', icon: 'icon-booking', cmp: 'Bookings' },
  payments: { labelKey: 'client.matters.matter_page.payments_title', icon: 'icon-payment', cmp: 'Payments' },
  documents: { labelKey: 'client.matters.matter_page.documents_title', icon: 'icon-document', cmp: 'Documents' },
  docuforms: {labelKey: 'client.matters.matter_page.docuforms_tab.tab_label', icon: 'icon-document', cmp: 'Docuforms'},
  info: { labelKey: 'client.matters.matter_page.info_title', icon: 'icon-main_info', cmp: 'MatterInfo' },
  contact: { labelKey: 'client.matters.matter_page.contact_title', cmp: 'ContactInfo', customCmp: true }
};

const getTabs = (...args) => {
  return args.filter(tab => tabs[tab]).map(tab => ({id: tab, ...tabs[tab]}));
};

export default {
  getTabs
}
